import { motion, useReducedMotion } from "framer-motion";
import { SectionLabel } from "@/components/primitives";

// Reusable internal-page hero with masked line reveal + grid backdrop.
export default function PageHero({ label, title, accent, subtitle, testId }) {
  const reduce = useReducedMotion();
  return (
    <section
      data-testid={testId}
      className="relative overflow-hidden border-b border-fs-border bg-fs-bg pb-16 pt-36 lg:pb-24 lg:pt-44"
    >
      <div className="fs-grid-bg pointer-events-none absolute inset-0 opacity-40" aria-hidden="true" />
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -right-20 top-10 h-72 w-72 rounded-full bg-fs-gold/[0.06] blur-3xl"
      />
      <div className="fs-shell relative">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
        >
          <SectionLabel testId={`${testId}-label`}>{label}</SectionLabel>
        </motion.div>
        <h1 className="mt-6 max-w-4xl fs-h1">
          <span className="block overflow-hidden">
            <motion.span
              className="block"
              initial={reduce ? { opacity: 0 } : { opacity: 0, y: "100%" }}
              animate={reduce ? { opacity: 1 } : { opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.1, ease: [0.22, 1, 0.36, 1] }}
            >
              {title}
            </motion.span>
          </span>
          {accent && (
            <span className="block overflow-hidden">
              <motion.span
                className="block fs-italic-gold"
                initial={reduce ? { opacity: 0 } : { opacity: 0, y: "100%" }}
                animate={reduce ? { opacity: 1 } : { opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.25, ease: [0.22, 1, 0.36, 1] }}
              >
                {accent}
              </motion.span>
            </span>
          )}
        </h1>
        {subtitle && (
          <motion.p
            className="mt-8 max-w-2xl fs-body"
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.4 }}
          >
            {subtitle}
          </motion.p>
        )}
      </div>
    </section>
  );
}
